package horcrux.common.types

import arrow.core.Either
import io.ktor.util.decodeBase64Bytes
import io.ktor.util.encodeBase64
import kotlinx.serialization.DeserializationStrategy
import kotlinx.serialization.SerializationStrategy
import kotlinx.serialization.json.Json

interface Transmittable {
    val mimeType: MimeType
    val byteArray: ByteArray
    val base64String: String
        get() = byteArray.encodeBase64()

    interface Companion<A : Transmittable> {
        fun deserializeFromByteArray(byteArray: ByteArray): Either<Throwable, A>
        fun deserializeFromBase64String(base64String: String): Either<Throwable, A> =
            deserializeFromByteArray(base64String.decodeBase64Bytes())
    }
}

interface JsonTransmittable : Transmittable {
    override val mimeType: MimeType
        get() = MimeType.APPLICATION_JSON

    val jsonString: String

    override val byteArray: ByteArray
        get() = jsonString.encodeToByteArray()

    interface Companion<A : Transmittable> : Transmittable.Companion<A> {
        val jsonSerializer: Json
            get() = Json.Default

        fun <A> serializeToJsonString(serializationStrategy: SerializationStrategy<A>, value: A): String =
            jsonSerializer.encodeToString(serializationStrategy, value)

        fun <A> deserializeFromBase64Json(
            deserializationStrategy: DeserializationStrategy<A>,
            byteArray: ByteArray
        ): Either<Throwable, A> =
            deserializeFromJson(deserializationStrategy, byteArray.decodeToString())

        fun <A> deserializeFromJson(
            deserializationStrategy: DeserializationStrategy<A>,
            json: String
        ): Either<Throwable, A> =
            Either.catch { jsonSerializer.decodeFromString(deserializationStrategy, json) }
    }
}
